/**
 * @desc 删除设备
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 设备ID */
  id?: number;
  /** 状态 */
  state?: number;
}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/web/equipment/remove',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/mock/web/equipment/remove',

    params,
  });
}
